import { useMutation, UseMutationResult } from "@tanstack/react-query";

// Extend the SprintMutation interface or its parts later if needed

interface SprintMutationParams<T, R> {
    mutationFn: (payload: T) => Promise<R>;
    onSettled?: () => Promise<void>;
}

export type SprintMutationResult<T, R = void> = UseMutationResult<R, unknown, T, unknown>;

export const useSprintMutation = <T, R = void>({
    mutationFn,
    onSettled
}: SprintMutationParams<T, R>): SprintMutationResult<T, R> => {
    return useMutation({
        mutationFn,
        onSettled
    });
};
